<script>
import {
  pointRetraitSelectorItemEmits,
  pointRetraitSelectorItemProps,
  usePointRetraitSelectorItem
} from "./mixin";
import Button from "@/components/atoms/button";
import FormRadio from "@/components/molecules/form-radio";
import Popin from "@/components/molecules/popin";
import LazyImage from "@/components/atoms/lazy-image";
import pictoStorelocLaposte from "@/assets/images/picto-storeloc-laposte.svg";
import pinR from "@/assets/images/pin-r.svg";

export default {
  name: "PointRetraitSelectorItemMobile",
  components: {
    Button,
    FormRadio,
    Popin,
    LazyImage
  },
  props: {
    checked: {
      type: Boolean,
      required: false,
      default: false
    },
    ...pointRetraitSelectorItemProps()
  },
  emits: [...pointRetraitSelectorItemEmits()],
  setup(props, context) {
    const { position, hasPosition, clicked } = usePointRetraitSelectorItem(
      props,
      context
    );
    return {
      position,
      hasPosition,
      clicked,
      pictoStorelocLaposte,
      pinR
    };
  }
};
</script>

<template>
  <component
    :is="disabled ? 'div' : 'Button'"
    align="left"
    class="c-point-retrait-selector-item"
    :class="disabled && 'c-point-retrait-selector-item--disabled'"
    @click="clicked()"
  >
    <Popin
      ref="raisonsIndispo"
      slide-up
      aria-label="Raisons de l'indisponibilité"
    >
      <p
        v-for="raison in raisonsImpossible"
        :key="`raison-${service.id}-${raison.type_raison}`"
        class="u-font-14 u-mb-xs u-mt-xs"
      >
        {{ raison.raison }}
      </p>
    </Popin>
    <div class="c-point-retrait-selector-item-content u-flex u-flex-justify-between">
      <div class="u-flex u-flex-justify-around u-flex-align-center">
        <FormRadio
          aria-hidden="true"
          tabindex="-1"
          :disabled="disabled"
          :checked="checked"
          size="lg"
          class="c-point-retrait-selector-item__radio"
        />
        <LazyImage
          class="u-ml-sm u-flex-self-start"
          :src="service.sous_type === 'LA_POSTE' ? pictoStorelocLaposte : pinR"
          width="20"
          height="20"
        />
        <div class="u-text-left u-ml-xs">
          <p class="u-mb-xxs">
            <strong>{{ service.description }}</strong>
          </p>
          <p class="u-mb-xxs">
            {{ service.adresse }}
            <template v-if="service.details">
              <br />
              {{ service.details }}
            </template>
          </p>
          <Button
            v-if="disabled"
            link
            @click="$refs.raisonsIndispo.show()"
          >
            <span class="u-font-15 u-color-text">Pourquoi est-il indisponible ?</span>
          </Button>
        </div>
      </div>
    </div>
  </component>
</template>

<style lang="scss" scoped>
.c-point-retrait-selector-item {
  width: 100%;
}
.c-point-retrait-selector-item--disabled {
  background: color(grey-8);
  color: color(text-light);
}
.c-point-retrait-selector-item-content {
  text-align: left;
  padding: spacing(sm);
  width: 100%;
  text-align: left;
}
.c-point-retrait-selector-item__radio {
  pointer-events: none;
}
</style>
